import React from "react";
import dayjs from "dayjs";

import {
  useRecoilValue,
  useRecoilValueLoadable,
  useSetRecoilState,
} from "recoil";
import { modalState } from "lib/store/common";
import {
  asyncGetRefundOrderDetail,
  refundDetailState,
  resetRefundDetail,
} from "lib/store/billing";

import { Modal } from "@atsent/components";

import "./RefundDetail.scss";

export type RefundDetailProps = {
  cx?: string;
};

const useGetRefundDetail = (order: number) => {
  const { state, contents } = useRecoilValueLoadable(
    asyncGetRefundOrderDetail(order)
  );
  let returnVal = {
    amount: 0,
    available_usage_per_day: 0,
    cost: 0,
    created_at: "",
    max_usage: 0,
    order: 0,
    paid_at: "",
    price: 0,
    price_per_day: 0,
    refund_at: "",
    standard_usage: 0,
    usage: 0,
    used_days: 0,
  };

  if (state === "hasValue") {
    return contents;
  }

  return returnVal;
};

export const RefundDetail: React.FC<RefundDetailProps> = ({ cx = "" }) => {
  const setModal = useSetRecoilState(modalState);
  const reset = useSetRecoilState(resetRefundDetail);
  const { uid, order, refundReceipt, receipt, type } =
    useRecoilValue(refundDetailState);
  const detail = useGetRefundDetail(order);
  return (
    <Modal
      title={`# ${uid}`}
      close={() => {
        setModal((_) => ({ ..._, refundDetail: false }));
        reset((_) => _);
      }}
      cx={`RefundDetail ${cx}`}
    >
      <h5>{type}</h5>
      <ul>
        <li>
          <span>결제 시각</span>
          <span>{dayjs(detail.paid_at).format("YYYY.MM.DD hh:mm:ss")}</span>
        </li>
        <li>
          <span>환불 시각</span>
          <span>{dayjs(detail.refund_at).format("YYYY.MM.DD hh:mm:ss")}</span>
        </li>
        <li>
          <div>
            <span>사용 일수 </span>
            <br />
            <span className={"small"}>환불 시각 - 결제 시각 (일)</span>
          </div>
          <span>{detail.used_days}</span>
        </li>
        <li>
          <span>플랜 최대 사용량</span>
          <span>{detail.max_usage.toLocaleString()}</span>
        </li>
        <li>
          <div>
            <span>1일 기준 사용량</span> <br />
            <span className={"small"}>플랜 최대 사용량 ÷ 30</span>
          </div>
          <span>{detail.available_usage_per_day.toLocaleString()}</span>
        </li>
        <li>
          <span>사용량 </span>
          <span>{detail.usage.toLocaleString()}</span>
        </li>
        <li>
          <div>
            <span>기준 사용량 </span>
            <br />
            <span className="small">사용 일수 x 1일 기준 사용량</span>
          </div>
          <span>{detail.standard_usage.toLocaleString()}</span>
        </li>
        <li>
          <span>플랜 가격</span>
          <span> ￦ {detail.price.toLocaleString()}</span>
        </li>
        <li>
          <div>
            <span>1일 기준 가격</span>
            <br />
            <span className={"small"}>플랜 가격 ÷ 30</span>
          </div>
          <span>￦ {detail.price_per_day.toLocaleString()}</span>
        </li>
        <li>
          <div>
            <span>비용</span>
            <br />
            <span className={"small"}>1) 기준 사용량보다 적게 사용 </span>
            <br />
            <span className={"small"}>= 1일 기준 가격 x 사용 일수</span>
            <br />
            <span className={"small"}>2) 기준 사용량보다 많이 사용 </span>
            <br />
            <span className={"small"}>
              = 플랜 가격 x (사용량/최대 사용량)
            </span>
          </div>
          <span> ￦ {detail.cost.toLocaleString()}</span>
        </li>
        <li>
          <span>환불 금액</span>
          <span> ￦ {detail.amount.toLocaleString()}</span>
        </li>
      </ul>
      <div className="receipt-wrapper">
        <span className="underline">
          <a href={receipt} target={"_blank"}>
            결제 영수증
          </a>
        </span>
        <span className="underline">
          <a href={refundReceipt} target={"_blank"}>
            환불 영수증
          </a>
        </span>
      </div>
    </Modal>
  );
};
